import React, { useCallback, useMemo } from "react";
import { Button, IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";
import {
  Add,
  Info,
  OpenInNew as OpenInNewIcon,
  Edit,
} from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import styles from "./Styles.module.css";
import DataTables from "./../../Datatables/Datatable.table";
import Constants from "./../../config/constants";
import FilterComponent from "./../../components/Filter/Filter.component";
import useProgramListHook from "./ProgramListHook";
import capitalizeFirstLetter from "./../../hooks/CommonFunction";
import { ArrowPrimaryButton, PrimaryButton } from "./../../components/Buttons/PrimaryButton";
import StatusPill from "./../../components/Status/StatusPill.component";
import ShadowBox from "../../components/ShadowBox/ShadowBox";
import BasicButtonGroup from "../../components/BasicButtonGroup/BasicButtonGroup";
import useRoles from "../../hooks/RoleHook";
import LogUtils from "../../libs/LogUtils";
import CircularProgress from "@mui/material/CircularProgress";
const CustomersList = (props) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    handleDetail,
    handleFilterDataChange,
    handleSearchValueChange,
    handleProfile,
    configFilter,
    handleCreate,
    handleEdit,
    handleExport,
    isSubmitting
  } = useProgramListHook({});

  const { canDelete, canRead, canCreate, canUpdate } = useRoles(
    Constants.MODULES.PROGRAM_MANAGEMENT
  );
  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.program);

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        {/* <img src={user.image} alt="" crossOrigin="anonymous" /> */}

        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
          <div> {user?.employee_id}</div>
        </div>
      </div>
    );
  }, []);
  //   const handleDelete = (all) => {
  //     let params = {
  //       id: all?.id,
  //     };
  //     serviceDeleteProduct(params);
  //   };
  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "name",
        label: "Program Name",
        sortable: true,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },
      {
        key: "client",
        label: "Client Name ",
        sortable: false,
        render: (temp, all) => (
          <div>
            {all?.client?.name
              ? all.client.name.charAt(0).toUpperCase() +
                all.client.name.slice(1)
              : ""}
          </div>
        ),
      },
      {
        key: "date",
        label: "Dates",
        sortable: false,
        render: (temp, all) => (
          <>
            <div className={styles.row}>
              <div>{`${all?.startDateText ?? "N/A"}`} </div>
              <div>{` - `}</div>
              <div> {`${all?.endDateText ?? "N/A"}`}</div>
            </div>
          </>
        ),
      },
      {
        key: "usersEnrolledCount",
        label: "User Enrolled",
        sortable: false,
        render: (temp, all) => <div>{all?.usersEnrolledCount ?? 0}</div>,
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all.status)}</div>,
      },

      {
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
            {canRead && (
              <>
                

                <span className={styles.info}>
                  <Tooltip
                    title={<>View Detail</>}
                    aria-label="info"
                    placement="right"
                    className={styles.infoTip}
                  >
                    <IconButton
                  disableRipple="false"
                  onClick={() => {
                    handleDetail(all);
                  }}
                >
                  <Info fontSize={"small"} />
                </IconButton>
                  
                  </Tooltip>
                </span>
              </>
            )}
            {/* {canUpdate &&<IconButton

                onClick={() => handleEdit(all)}
              >
                <Edit fontSize={"small"} />
              </IconButton>} */}
          </div>
        ),
      },
    ],
    [renderFirstCell, renderStatus, handleDetail, handleProfile]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    present,
    currentPage,
  ]);

  return (
    <ShadowBox className={styles.contact}>
      {/* <div className={"plainPaper"}> */}
      <div className={styles.headerContainer}>
        <Typography
          variant={"h5"}
          color={"text.primary"}
          className={styles.title}
        >
          Program List
        </Typography>
        {/* {canCreate && <ArrowPrimaryButton
          onClick={handleCreate}
          icon={<Add fontSize="normal" />}
        >
          CREATE
        </ArrowPrimaryButton>
         } */}
         <PrimaryButton
          onClick={handleExport}
          disabled={isSubmitting}
        >
          {isSubmitting ? (  <CircularProgress size={24} color={"primary"} /> ) : ("EXPORT")}
        </PrimaryButton>
         
      </div>

      <div>
        
        <FilterComponent
          is_progress={isFetching}
          filters={configFilter}
          handleSearchValueChange={handleSearchValueChange}
          handleFilterDataChange={handleFilterDataChange}
          placeholder="Search by program name"
        />
        
        <div>
          <br />
          <div style={{ width: "100%" }}>
            <DataTables
              {...tableData.datatable}
              {...tableData.datatableFunctions}
            />
          </div>
        </div>
      </div>
      {/* </div> */}
    </ShadowBox>
  );
};

export default CustomersList;
